export default __webpack_public_path__ + "static/media/phone.e1e12a24.svg";